export default __webpack_public_path__ + "static/media/Snd_CE.248c2800.mp3";